module.exports = __webpack_public_path__ + "static/film3-e1418fdd29e25ed549237d003683d484.jpg";